import { ThemeSelector } from '@almbrand/themeselector';
import { PageType } from 'components/PageType';
import { CONTENT_DELIVERY_API_URL } from 'constantsValues';
import { useMemo } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import styles from './App.module.scss';
import { Page as PageContent, PageContext } from './context/PageContext';
import { apiInstance } from './services/Api';
import { purifyApiUrl } from './services/purifyApiUrl';
import { configureRecaptcha } from './services/Recaptcha';

const App = () => {
	const location = useLocation();
	const { data, error, isLoading } = useSWR(location.pathname, (): any => {
		return apiInstance().get(purifyApiUrl(location.pathname, CONTENT_DELIVERY_API_URL));
	});

	const pageValue = useMemo(() => new PageContent(data), [data]);

	// Initialise reCAPTCHA v3 during render, NOT in a useEffect. Effects run
	// bottom-up (child effects fire before the parent's), so child components
	// that trigger API calls on mount (SearchField, CarSearch, ...) would
	// otherwise fire their first open-proxy request before configureRecaptcha
	// has run — and the interceptor in Api.ts would fail closed.
	// We only call once the CMS page model is available: that first call marks
	// the config as loaded (unblocking the fail-closed guard in Recaptcha.ts)
	// and hands over the CMS-owned protected-path list. configureRecaptcha is
	// idempotent, so calling it on every render with the same values is safe.
	const pageModel = pageValue?.pageModel;
	if (pageModel) {
		const recaptchaSiteKey = pageModel.frontendConfiguration?.recaptchaSiteKey;
		const reCaptchaProtectedPaths = pageModel.frontendConfiguration?.reCaptchaProtectedPaths;
		configureRecaptcha(recaptchaSiteKey, reCaptchaProtectedPaths);
	}

	return (
		<ThemeSelector themeName={pageValue.theme}>
			{error && <div>Error fetching content: {error.message}</div>}
			<div
				className={styles.App}
				data-page-type={pageValue?.pageType}
			>
				{isLoading}
				{data && (
					<PageContext.Provider value={pageValue}>
						<Routes>
							{/* <Route path='/'> */}
							<Route
								path='/:flowName'
								element={<PageType />}
							/>
							<Route
								path='*'
								element={<PageType />}
							/>
							{/* </Route> */}
						</Routes>
						{/* <PageType /> */}
					</PageContext.Provider>
				)}
			</div>
		</ThemeSelector>
	);
};

export default App;
